import { useEffect, useState } from 'react';

/**
 * 高德地图API配置
 * 注意：在生产环境中，您需要替换以下两个值为实际申请的高德地图API密钥
 * 1. key: 高德地图API Key (在高德开放平台申请)
 * 2. securityJsCode: 高德地图安全密钥 (在高德开放平台申请)
 * 
 * 申请地址：https://lbs.amap.com/
 * 
 * 申请步骤：
 * 1. 注册高德开放平台账号
 * 2. 进入控制台创建应用
 * 3. 为应用添加Key，服务平台选择"Web端(JS API)"
 * 4. 获取Key和安全密钥
 */
const MAP_CONFIG = {
    // 替换为实际的高德地图API Key
    key: '',
    // 替换为实际的高德地图安全密钥  
    securityJsCode: 'ae0ba8ae925120b3d37242dcf1d748d5',
    version: '1.4.15'
};

/**
 * 异步加载高德地图API的自定义Hook
 * 
 * 使用方法：
 * const { aMap, loading, error } = useAMap();
 * 
 * 返回值：
 * - aMap: 高德地图API对象 (加载完成后可用)
 * - loading: 是否正在加载
 * - error: 加载错误信息
 */
export const useAMap = () => {
    const [aMap, setAMap] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // 检查是否已经加载过
        if (window.AMap) {
            setAMap(window.AMap);
            setLoading(false);
            return;
        }

        // 设置安全密钥
        window._AMapSecurityConfig = {
            securityJsCode: MAP_CONFIG.securityJsCode
        };

        // 创建加载回调函数
        window.onAMapLoad = () => {
            setAMap(window.AMap);
            setLoading(false);
        };

        // 创建脚本标签
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://webapi.amap.com/maps?v=${MAP_CONFIG.version}&key=${MAP_CONFIG.key}&callback=onAMapLoad`;
        script.onerror = () => {
            setError('Failed to load AMap SDK');
            setLoading(false);
        };

        document.head.appendChild(script);

        // 清理函数
        return () => {
            document.head.removeChild(script);
            delete window.onAMapLoad;
            delete window._AMapSecurityConfig;
        };
    }, []);

    return { aMap, loading, error };
};